





















































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import PartnershipSteps from '@ui/AudienceSetWizard/PartnershipStep/PartnershipSteps'
import AudienceAvailabilityList from '@ui/AudienceSetWizard/components/AudienceAvailabilityList'
import TagBar from '@ui/TagBar'
import TreeSelector from '@ui/TreeSelector'

settings =
  name: 'PartnershipProhibitedCategoriesStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      StepContainer,
      PartnershipSteps,
      AudienceAvailabilityList,
      TagBar,
      TreeSelector,
    }

    data: ->
      allSelected: false
      selectedAudienceAvailabilityKeys: []
      selectedCategories: []

    computed:
      lastSelectedCategory: -> [@selectedCategories[@selectedCategories.length - 1]]
      listingTypes: -> @$store.marketplace.listing.types
      optionsForTagBar: ->
        {
          bar: {
            theme: 'danger',
            max: 2
          },
          tag: {
            theme: 'danger',
            maxLength: 12
          }
        }

      audienceAvailabilities: -> @wizard.audienceSetData.audience_availabilities
      hasAudienceAvailabilitiesSelected: -> @selectedAudienceAvailabilityKeys.length > 0

      brandCategoriesOptions: ->
        mapping = @marketplace?.brand?.categories || {}
        tree = @marketplace?.brand?.category_tree || {}
        tree.other ||= "Other" # auto add as a top level category
        @jsonToElementUICascader tree, mapping
      brandCategoriesActions: ->
        select: @selectBrandCategories

    methods:
      hiToggleAllSelected: (checked) ->
        if checked
          @selectedAudienceAvailabilityKeys = @audienceAvailabilities.map((item) -> item.key)
        else
          @selectedAudienceAvailabilityKeys = []

      hiAddCategories: ->
        for item in @getSelectedAudienceAvailabilities()
          categories = [...@lastSelectedCategory, ...item.restrictions.catex.prohibited]
          item.restrictions.catex.prohibited = Array.from(new Set(categories))
        @reset()

      hiRemoveCategories: ->
        for item in @getSelectedAudienceAvailabilities()
          categories = item.restrictions.catex.prohibited.filter((c) => c not in @lastSelectedCategory)
          item.restrictions.catex.prohibited = categories
        @reset()

      reset: ->
        @selectedAudienceAvailabilityKeys = []
        @selectedCategories = []

      actionsForTagBar: (audienceAvailability) ->
        onRemove: (category) => @removeProhibitedCategory(category, audienceAvailability)

      removeProhibitedCategory: (category, audienceAvailability) ->
        audienceAvailability.restrictions.catex.prohibited = audienceAvailability.restrictions.catex.prohibited.filter((c) -> c isnt category)

      getSelectedAudienceAvailabilities: ->
        @audienceAvailabilities.filter((item) => item.key in @selectedAudienceAvailabilityKeys)

      loadCategoriesForSelectedAudienceAvailabilities: ->
        categories = []
        for item in @getSelectedAudienceAvailabilities()
          categories.push ...item.restrictions.catex.prohibited
        @selectedCategories = Array.from(new Set(categories))

      selectBrandCategories: (categories) ->
        @selectedCategories = categories

    watch:
      selectedAudienceAvailabilityKeys: ->
        @allSelected = @selectedAudienceAvailabilityKeys.length is @audienceAvailabilities.length

export default VueOptions.vue settings
